module.exports = __webpack_public_path__ + "img/onboarding-completed-uae.53eb18b7.png";